import React from 'react';
import { MapPinIcon, MailIcon, ClockIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { CONTACT, PRACTICE } from '../content/site';
import { PageHeader } from '../components/blocks/PageHeader';
import { ConsultationForm } from '../components/blocks/ConsultationForm';
import { Section, Reveal } from '../components/ui/Primitives';
export function ContactPage() {
  const {
    language
  } = useLanguage();
  const t = CONTACT[language];
  const details = [{
    icon: MapPinIcon,
    label: t.labels.address,
    value: PRACTICE.addressLines
  }, {
    icon: MailIcon,
    label: t.labels.email,
    value: [PRACTICE.email],
    href: `mailto:${PRACTICE.email}`
  }, {
    icon: ClockIcon,
    label: t.labels.hours,
    value: [t.hours]
  }, {
    icon: GlobeIcon,
    label: t.labels.languages,
    value: [t.languages]
  }];
  return <>
      <PageHeader eyebrow={t.eyebrow} title={t.title} sub={t.sub} data-id="element-233" data-mp="1qd8d6gdtcjd4" />

      <Section tone="white" data-id="element-234" data-mp="r0okitphzj21">
        <div className="grid gap-px overflow-hidden rounded-2xl border border-espresso/10 bg-espresso/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-235" data-mp="r0yfkvpeggel">
          {details.map((item, index) => {
          const Icon = item.icon;
          return <Reveal key={item.label} delay={index * 0.07} data-id="element-236" data-mp="hy5n4p4hdyn6" data-mpi={index}>
                <div className="h-full bg-white p-7 lg:p-8" data-id="element-237" data-mp="d1p05y90pqbo">
                  <Icon className="mb-5 h-4 w-4 text-bronze" strokeWidth={1.5} data-id="element-238" data-mp="81srvmtafcqb" />
                  <h2 className="mb-3 text-[10px] font-semibold uppercase tracking-[0.18em] text-espresso/45" data-id="element-239" data-mp="3a1bg53uindw">
                    {item.label}
                  </h2>
                  <div className="text-sm font-light leading-relaxed text-espresso/80" data-id="element-240" data-mp="3qg21uba4c9k1">
                    {item.href ? <a href={item.href} className="break-words transition-colors hover:text-bronze" data-id="element-241" data-mp="3lgywepq881bj">
                        {item.value[0]}
                      </a> : item.value.map(line => <span key={line} className="block" data-id="element-242" data-mp="3btw9qw7w52df">
                          {line}
                        </span>)}
                  </div>
                </div>
              </Reveal>;
        })}
        </div>
      </Section>

      <Section tone="cream" data-id="element-243" data-mp="3plj7l0hheiyb">
        <ConsultationForm data-id="element-244" data-mp="3pl9rc4m8nq5t" />
      </Section>
    </>;
}